// third-party

// assets
import { ApartmentOutlined } from '@ant-design/icons';
import { OPERATIONS } from 'constants';

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const clients = {
  id: 'clients',
  title: 'Clients',
  type: 'group',
  children: [
    {
      id: 'lines_of_business',
      title: 'Lines of Business',
      type: 'item',
      url: '/clients/lines-of-business',
      icon: ApartmentOutlined,
      operations: [OPERATIONS.VIEW, OPERATIONS.EDIT]
    }
  ]
};

export default clients;
